import React from 'react';
import { StarIcon, UserIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
function Stars({
  size = 'w-4 h-4'
}: {
  size?: string;
}) {
  return <div className="flex gap-0.5" aria-hidden="true" data-id="element-150" data-mp="1n00oxxcf8rsi">
      {[...Array(5)].map((_, i) => <StarIcon key={i} className={`${size} fill-amber-400 text-amber-400`} data-id="element-151" data-mp="1my7pb20877u0" data-mpi={i} />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-152" data-mp="1d133j3aaledq">
      <div className="max-w-6xl mx-auto" data-id="element-153" data-mp="1i0xtn4m8tzxq">
        <div className="text-center mb-16" data-id="element-154" data-mp="1i1z3x6vfqiee">
          <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-4" data-id="element-155" data-mp="1hyl2q1yicf8j">
            Lo que dicen las instructoras de Argentina
          </h2>
          <div className="flex items-center justify-center gap-2 text-brand-gray font-medium" data-id="element-156" data-mp="183t5x0cr1wet">
            <Stars size="w-5 h-5" data-id="element-157" data-mp="2yexnpyyeqvd2" />
            <span data-id="element-158" data-mp="2yfz0q8yzhrxf">[X] reseñas verificadas</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-159" data-mp="32fhp5eq0kl50">
          {testimonials.map(t => <figure key={t.initials} className="bg-brand-panel rounded-3xl p-8 flex flex-col h-full border border-brand-creamDark/60" data-id="element-160" data-mp="2uzrkr7su7nn8">
              <Stars data-id="element-161" data-mp="34q2nws4p5st2" />
              <blockquote className="text-brand-text font-medium my-6 leading-relaxed" data-id="element-162" data-mp="34qm3w3ase74g">
                “{t.quote}”
              </blockquote>
              <figcaption className="flex items-center gap-4 mt-auto" data-id="element-163" data-mp="2c26t5syouayx">
                <span className="w-10 h-10 rounded-full bg-brand-greenDark text-white flex items-center justify-center shrink-0" data-id="element-164" data-mp="2c4jkgwqc5xon">
                  <UserIcon className="w-5 h-5" aria-hidden="true" data-id="element-165" data-mp="2m1fksf62zdi4" />
                </span>
                <span data-id="element-166" data-mp="2h22wrr3h40dy">
                  <span className="block font-bold text-brand-text text-sm" data-id="element-167" data-mp="2h0rtrthuqwnw">
                    {t.name}
                  </span>
                  <span className="block text-xs text-brand-gray" data-id="element-168" data-mp="18u96h59n92k">
                    {t.role}
                  </span>
                  <span className="block text-xs text-brand-gray" data-id="element-169" data-mp="3sjb0092dvagj">
                    {t.location}
                  </span>
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}